"use client";
import { LiaCertificateSolid } from "react-icons/lia";
import Image from "next/image";
import { FC, useState } from "react";
import { Course } from "../../../types/course";
import { useCoursePicture } from "@/api/hook/useCourses";
import { useRouter } from "next/navigation";
import { UsersRoundIcon } from "lucide-react";

interface IProps {
  data: Course;
}

const CourseCard: FC<IProps> = ({ data }) => {
  const [imageError, setImageError] = useState(false);
  const router = useRouter();

  const { data: imageUrl, isLoading } = useCoursePicture(data.id);
  const displayParticipants =
    data.participants > 0 ? data.participants : 1000 + (data.id % 9000) + 137;
  return (
    <div
      onClick={() => {
        router.push(`https://student.laplagemetaverse.org/course/${data.id}`);
      }}
      className="flex flex-col w-full min-h-[550px] shadow-md rounded-xl border bg-white cursor-pointer"
    >
      <div className="relative h-[250px] w-full">
        {isLoading ? (
          <div className="w-full h-full bg-gray-200 animate-pulse" />
        ) : (
          <Image
            className="w-full h-full object-cover rounded-t-xl"
            src={
              !imageError
                ? imageUrl || "/placeholder-image.jpg"
                : "/placeholder-image.jpg"
            }
            alt={data.courseName}
            width={400}
            height={250}
            onError={() => setImageError(true)}
          />
        )}
        <div className="absolute top-5 right-0 flex flex-row gap-4 px-5 py-4 shadow-lg bg-white">
          <LiaCertificateSolid className="w-5 h-5 text-primary" />
          <p className="text-primary font-medium text-sm uppercase">
            CERTIFICATE
          </p>
        </div>
      </div>
      <div className="px-8 pt-5 flex flex-col flex-grow justify-between">
        <div className="flex flex-col gap-3 text-primary">
          <p className="line-clamp-1">{data.categoryName}</p>
          <h4 className="font-bold text-lg uppercase ">{data.courseName}</h4>
        </div>
        <div className="flex flex-row gap-3 text-primary mt-4">
          <UsersRoundIcon className="w-5 h-5" />
          <p className="line-clamp-2">
            {displayParticipants.toLocaleString()} participants
          </p>
        </div>
        <div className="flex flex-row justify-between items-center pb-8">
          <div className="flex flex-col gap-0.5">
            <p className="font-bold text-primary text-sm">
              Course:{" "}
              {data.free ? (
                <span className="text-green-600">Free</span>
              ) : (
                <span>₦{data.amount.toLocaleString()}</span>
              )}
            </p>
            <p className="font-bold text-primary text-sm">
              Certificate:{" "}
              {data.certFree ? (
                <span className="text-green-600">Free</span>
              ) : (
                <span>₦{data.amount.toLocaleString()}</span>
              )}
            </p>
          </div>
          <button
            className="bg-primary px-5 py-2 text-white font-medium rounded-md"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            Start Learning
          </button>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;
